import React from 'react'
import { css } from 'glamor'
import { toast } from 'react-toastify'
import CloseButton from './toast-close-button'
import Button from '../button'

const formatParagraph = (msg, index) => {
  return (
    <p
      key={index ? index : null}
      style={{
        padding: '2% 5% 0 5%',
        boxSizing: 'border-box',
        textAlign: 'justify',
        margin: '0'
      }}
    >
      {msg}
    </p>
  )
}

export default {
  baseMapSubscription(msg, options, onClick = {}) {
    let messageArray = Array.isArray(msg) ? [...msg] : [msg]
    messageArray.push('Would you like to upgrade now?')
    let message = messageArray.map((m, i) => formatParagraph(m, i))
    return toast(
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <div>
          <img src="../../asset/corp-logo-app-bar.png" />
        </div>
        <div style={{ width: '100%' }}>
          {message}

          <Button
            type="button"
            ripple
            style={{ margin: '5%' }}
            onClick={() => {
              if (/\bFavorite\b/.test(message[0].props.children)) {
                Countly.q.push([
                  'add_event',
                  {
                    key: 'Upgrade',
                    count: 1,
                    segmentation: {
                      'Initiated From': 'Favorite Location'
                    }
                  }
                ])
              }
              if (/\bland\b/.test(message[0].props.children)) {
                Countly.q.push([
                  'add_event',
                  {
                    key: 'Upgrade',
                    count: 1,
                    segmentation: {
                      'Initiated From': 'Private Parcels'
                    }
                  }
                ])
              }
              if (/\blimit\b/.test(message[0].props.children)) {
                Countly.q.push([
                  'add_event',
                  {
                    key: 'Upgrade',
                    count: 1,
                    segmentation: {
                      'Initiated From': 'Item Limit'
                    }
                  }
                ])
              }
              if (/\bImport\b/.test(message[0].props.children)) {
                Countly.q.push([
                  'add_event',
                  {
                    key: 'Upgrade',
                    count: 1,
                    segmentation: {
                      'Initiated From': 'KML'
                    }
                  }
                ])
              }
              onClick()
            }}
          >
            Upgrade
          </Button>
          <CloseButton />
        </div>
      </div>,

      {
        ...options,
        className: {
          color: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '8px',
          background: '#000000',
          boxShadow: '2px 2px 20px 2px rgba(0,0,0,0.3)',
          cursor: 'default'
        },
        progressClassName: css({
          background: 'rgb(144, 255, 0)'
        })
      }
    )
  },
  baseMapError(msg, options = {}, cancelText) {
    return toast(
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <div>
          <img src="../../asset/corp-logo-app-bar.png" />
        </div>
        <div style={{ width: '100%' }}>
          <p
            style={{
              padding: '10px',
              boxSizing: 'border-box',
              textAlign: 'center'
            }}
          >
            {msg}
          </p>
        </div>
        <CloseButton closeToast={options.closeToast} text={cancelText} />
      </div>,

      {
        ...options,
        className: {
          color: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '8px',
          background: '#000000',
          boxShadow: '2px 2px 20px 2px rgba(0,0,0,0.3)',
          cursor: 'default'
        },
        progressClassName: css({
          background: 'rgb(144, 255, 0)'
        })
      }
    )
  },

  baseMapTransaction(msg, options = {}) {
    return toast(
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <div>
          <img src="../../asset/corp-logo-app-bar.png" />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <img style={{ width: '20%' }} src="../../asset/loading-spinner.gif" />
        </div>

        <div style={{ width: '100%' }}>
          <p
            style={{
              padding: '10px',
              boxSizing: 'border-box'
            }}
          >
            {msg}
          </p>
        </div>
      </div>,

      {
        ...options,
        className: {
          color: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '8px',
          background: '#000000',
          boxShadow: '2px 2px 20px 2px rgba(0,0,0,0.3)',
          cursor: 'default'
        },
        progressClassName: css({
          background: 'rgb(144, 255, 0)'
        })
      }
    )
  },

  baseMapNotification(msg, title, options = {}) {
    return toast(
      <div
        style={{
          display: 'inline-block',
          padding: '5px',
          width: '300px'
        }}
      >
        <div style={{ float: 'left', width: '100%', height: 'auto' }}>
          <img src="../../asset/Basemap_Logo_Delta_Square32x32.png" />
          <p
            style={{
              padding: '5px',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              width: '80%',
              display: 'inline-block',
              overflow: 'hidden',
              textAlign: 'left'
            }}
          >
            {title}
          </p>
          <p
            style={{
              padding: '5px',
              whiteSpace: 'pre-line',
              width: '95%',
              display: 'inline-block',
              overflow: 'hidden',
              textAlign: 'left',
              fontSize: 'small'
            }}
          >
            {msg}
          </p>
        </div>
      </div>,

      {
        ...options,
        position: toast.POSITION.TOP_RIGHT,
        className: {
          color: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '8px',
          background: '#000000',
          boxShadow: '2px 2px 20px 2px rgba(0,0,0,0.3)',
          cursor: 'default',
          border: '1px solid rgb(79, 79, 79, 0.5)'
        },
        progressClassName: css({
          background: 'rgb(144, 255, 0)'
        })
      }
    )
  }
}
